module.exports = __webpack_public_path__ + "img/palmar-spa.fb6233f9.jpg";